/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAggregateResult
 */
export interface IAggregateResult {
    /**
     * 
     * @type {string}
     * @memberof IAggregateResult
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IAggregateResult
     */
    text?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IAggregateResult
     */
    readonly value?: number | null;
}

/**
 * Check if a given object implements the IAggregateResult interface.
 */
export function instanceOfIAggregateResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IAggregateResultFromJSON(json: any): IAggregateResult {
    return IAggregateResultFromJSONTyped(json, false);
}

export function IAggregateResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAggregateResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function IAggregateResultToJSON(value?: IAggregateResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'text': value.text,
    };
}

